import React, { useContext, useEffect, useState } from "react";
import FirstVendor from "./FirstVendor/FirstVendor";
import SecondVendor from "./SecondVendor/SecondVendor";
import RateAndReview from "./RateAndReview/RateAndReview";

import { useLocation, useNavigate } from "react-router-dom";
import { getProductDetail } from "../../utils/apis/Product/Product";
import { getCartCheck } from "../../utils/apis/addToCart/addToCart";
import { Context } from "../../utils/context";
import Cookies from "js-cookie";
import Similar_Products from "./similar_products/Similar_Products";
import { useParams } from "react-router-dom";
import { decodeId } from "../../utils/common";

const VendorPage = () => {
  const { id } = useParams();

  const { signin, variant } = useContext(Context);
const [selectedVariant, setSelectedVariant] = useState();
  const [product, setProduct] = useState();
  const [cartStatus, setCartStatus] = useState(false);
  const [cartData, setCartData] = useState();
  const [variantId, setVariantId] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const user_id = decodeURIComponent(queryParams.get("user_id"));

  const [product_id, setproduct_id] = useState("");
  // let product_id;

  useEffect(() => {
    if (product_id && user_id && user_id != null && user_id != "null") {
      const data = {
        product_id,
        user_id,
      };

      Cookies.set("product_share", JSON.stringify(data), {
        expires: 1,
      });
    }
  }, [user_id, product_id]);

  const getProduct = async (product_id) => {
    if (product_id) {
      const res = await getProductDetail(product_id);
      if (res?.success) {
        setProduct(res?.data);
        setSelectedVariant(res?.data?.product_variants[0])

        const data = { product_id, variant_id: variant?.id };
        const response = await getCartCheck(data);

        if (response?.success) {
          setCartStatus(true);
          setCartData(response?.cartItem);
        }
      }
    }
  };

  useEffect(() => {
    if (id) {
      const decodedProductId = decodeId(id);
      setproduct_id(decodedProductId);
    }
  }, [id]);

  useEffect(() => {
    if (product_id) {
      getProduct(product_id);
    }
  }, [product_id]);

  return (
    <>
      <FirstVendor
        product_id={product_id}
        product={product}
        cartStatus={cartStatus}
        setCartStatus={setCartStatus}
        cartData={cartData}
        getProduct={getProduct}
        setVariantId={setVariantId}
        setCartData={setCartData}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
      />
      <Similar_Products product={product} />
      <RateAndReview product={product} />

      <SecondVendor heading="You may also like" product={product} />
    </>
  );
};

export default VendorPage;
